export const OAUTH_RESPONSE = 'oauth2-response';

export type OAuthMessage =
  | {
      type: typeof OAUTH_RESPONSE;
      error: string;
    }
  | {
      type: typeof OAUTH_RESPONSE;
      code: string;
    };

export const queryToObject = (query: string): Record<string, string> => {
  const parameters = new URLSearchParams(query);
  return Object.fromEntries(parameters.entries());
};

export const objectToQuery = (object: Record<string, string>): string =>
  new URLSearchParams(object).toString();

//#region - state helps to ensure the OAuth2 request and response correspond
export const generateState = (): string => {
  const validChars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const unassignedIntegers = new Uint8Array(40);
  window.crypto.getRandomValues(unassignedIntegers);
  const codePointValues = [...unassignedIntegers]
    .map((value) => validChars.codePointAt(value % validChars.length))
    .filter((value): value is number => Boolean(value));
  return String.fromCharCode(...codePointValues);
};

const OAUTH_STATE_KEY = 'oauth2-state-key';
export const saveGeneratedState = (state: string): void => {
  sessionStorage.setItem(OAUTH_STATE_KEY, state);
};
export const getGeneratedState = (): string | null =>
  sessionStorage.getItem(OAUTH_STATE_KEY);

export const removeGeneratedState = (): void => {
  sessionStorage.removeItem(OAUTH_STATE_KEY);
};

export const equalsToGeneratedState = (
  receivedState: string | undefined
): boolean => Boolean(receivedState) && receivedState === getGeneratedState();
//#endregion
